<template>
    <div>
        <Dialog
                :dismissableMask="true"
                :modal="true"
                :visible.sync="show"
                @hide="closeDialogAndReset"
                :contentStyle="{ overflow: 'visible' }"
                :maximizable="true"
        >
            <template #header>
                <i style="transform: scale(1.7)" class="pi pi-book"></i>
                <h1 style="text-align: center" class="p-pr-3 p-pl-3">
                    התקדמות בלימוד</h1>
            </template>

            <div class="p-pt-4 p-ai-center vertical-container p-flex-column p-grid">
                <!--                <div v-if="grade === undefined" class="p-col">-->
                <!--                    <select-grade :returnFullObject="true" @onSelect="updateGrade"/>-->
                <!--                </div>-->
                <div class="p-col">
                    <!--   subjectLesson  -->
                    <Dropdown
                            class="danger"
                            :filter="true"
                            optionLabel="hebrewName"
                            filterPlaceholder=" חפש לפי נושא"
                            emptyFilterMessage=" לא נמצא שם נושא תואם"
                            v-model="newItem.subject"
                            :options="subjectLesson"
                            placeholder="נושא השיעור"
                            data-key="id"
                    >
                        <template #value="slotProps">

                            <div :class="subjectClass" v-if="slotProps.value">
                                <span>{{ slotProps.value.hebrewName }} </span>
                            </div>
                            <span v-else>
                {{ slotProps.placeholder }}
              </span>
                        </template>
                        <template #option="slotProps">
                            <span>{{ slotProps.option.hebrewName }} </span>
                        </template>
                    </Dropdown>
                    <!--                    <h1 v-else>{{ newItem && newItem.subject && newItem.subject.hebrewName}} </h1>-->
                </div>
                <div :class="subjectClass" v-if="subjectLessonSchedule && subjectLessonSchedule !== newItem.subject.id">שים לב שנושא השיעור לא תואם את הנושא שמשוייך במערכת שעות</div>

                <!--   content  -->
                <div class="p-col">
          <Textarea
                  placeholder="תוכן הלימוד"
                  type="text"
                  v-model="newItem && newItem.content"
                  rows="2"
                  cols="20"
          />
                    <!--            <InputText  />-->
                </div>

                <div class="p-grid p-pt-3 p-jc-center">
                    <!-- time -->
                    <div
                            v-tooltip.top="'שעה'"
                            class="selected-details p-col p-grid p-jc-center p-m-2 p-p-2"
                            v-if="lessonTime"
                    >
                        <i class="pi p-pt-3 pi-clock" style="font-size: 1.5rem"></i>
                        <Divider type="dashed" class="divider-short-dialog"/>
                        <h3 style="text-align: center !important">
                            {{ lessonTime.hebrewName }}
                        </h3>
                    </div>

                    <!-- date-->
                    <div
                            v-tooltip.top="'תאריך'"
                            class="selected-details p-col p-grid p-jc-center p-m-2 p-p-2"
                            v-if="date"
                    >
                        <i class="pi p-pt-3 pi-calendar" style="font-size: 1.5rem"></i>
                        <Divider type="dashed" class="divider-short-dialog"/>
                        <h3 style="text-align: center !important">
                            {{ dateformat }}
                        </h3>
                    </div>

                    <!-- grade-->
                    <div
                            v-tooltip.top="'כיתה'"
                            class="selected-details p-col p-grid p-jc-center p-m-2 p-p-2"
                            v-if="grade"
                    >
                        <i class="pi p-pt-3 pi-th-large" style="font-size: 1.5rem"></i>
                        <Divider type="dashed" class="divider-short-dialog"/>
                        <h3 style="text-align: center !important">
                            {{ grade.hebrewName }}
                        </h3>
                    </div>

                    <!-- teacher-->
                    <div
                            v-tooltip.top="'מורה מדווח'"
                            v-if="studObjSelected"
                            class="selected-details p-col p-grid p-jc-center p-m-2 p-p-2"
                    >
                        <i class="pi p-pt-3 pi-user" style="font-size: 1.5rem"></i>
                        <Divider type="dashed" class="divider-short-dialog"/>
                        <h3 style="text-align: center !important">
                            {{ studObjSelected.user.firstname }}
                            {{ studObjSelected.user.lastname }}
                        </h3>
                    </div>
                </div>
            </div>

            <template #footer>
                <Button
                        label="ביטול"
                        icon="pi pi-times"
                        @click="closeDialogAndReset"
                        class="p-button-secondary"
                />
                <span v-if="studObjSelected">
          <Button
                  class="p-button-danger"
                  label="מחק"
                  icon="pi pi-trash"
                  @click="deleteStud"
          />
          <Button
                  v-if="validateToPost"
                  class="p-button-success"
                  label="עדכן"
                  icon="pi pi-check"
                  @click="post"
          />
          <Button
                  v-else
                  disabled="disabled"
                  class="p-button-success"
                  label="דיווח"
                  icon="pi pi-check"
          />
        </span>
                <span v-else>
          <Button
                  v-if="validateToPost"
                  class="p-button-success"
                  label="שמור דיווח"
                  icon="pi pi-check"
                  @click="post"
          />
          <Button
                  v-else
                  disabled="disabled"
                  class="p-button-success"
                  label="שמור דיווח"
                  icon="pi pi-check"
          />
        </span>
            </template>
        </Dialog>
    </div>
</template>

<script>
import Service from "../service/Service";
import {dateToFullHebrew} from "../../src/utils/hebrewDateFormat";
import {getGrade, getTeacher, getTopic} from "@/utils/parseObj";
import {mapState} from "vuex";
import SelectGrade from "@/components/selects/SelectGrade";

const {v4: uuidv4} = require("uuid");

export default {
    components: {SelectGrade},
    service: null,
    props: {
        show: Boolean,
        lessonTime: Object,
        subjectLessonSchedule: String,
        date: Date,
        grade: Object,
        gradeId: {
            type: String,
            default: null
        },
        content: {
            type: String,
            default: null
        },
        studObjSelected: Object,
    },
    created() {
        this.service = new Service();
        // this.setNewItwmFields();
    },
    watch: {
        show(a, b) {
            if (a) {
                this.setNewItwmFields();
            }
        },
    },
    computed: {
        subjectClass() {
            if (this.subjectLessonSchedule && this.subjectLessonSchedule !== this.newItem.subject.id) {
                return `t-danger`
            }
        },
        // subjectLessonSchedule(){
        //     return this.subjectLessonSchedule
        // },
        dateformat() {
            return dateToFullHebrew(this.date);
        },
        validateToPost() {
            let isValid =
                this.newItem.subject !== null && this.newItem.subject !== "";
            if (process.env.VUE_APP_SETTINGS_REQUIER_CONTENT_OF_STUDY === true) {
                isValid =
                    isValid &&
                    this.newItem.content !== null &&
                    this.newItem.content !== "";
            }

            return isValid;
        },
        ...mapState(["presenceStatus", "pupils", "user", "subjectLesson"]),
    },
    data() {
        return {
            newItem: null,
        };
    },

    methods: {
        updateGrade(grade) {
            this.grade = grade
        },
        postTitle() {
            return "cd";
            // this.studObjSelected ? "עדכן דיווח" : "שמור דיווח"
        },
        getGradeObj(gradeId) {
            return this.gradeOptions.find((grade) => grade.id === gradeId);
        },
        setNewItwmFields() {
            if (this.gradeId !== null) {
                this.grade = getGrade(this.gradeId)
            }
            if (this.studObjSelected) {
                if (this.studObjSelected.user !== undefined && this.studObjSelected.user.id === undefined) {
                    this.studObjSelected.user = getTeacher(this.studObjSelected.user)
                }
                if (this.studObjSelected.subject !== undefined && this.studObjSelected.subject.id === undefined) {
                    this.studObjSelected.subject = getTopic(this.studObjSelected.subject)
                }
                this.newItem = {
                    content: this.studObjSelected?.content || "",
                    subject: this.studObjSelected?.subject || '',
                };
            } else if (this.subjectLessonSchedule) {
                this.newItem = {
                    content: this.content,
                    subject: this.subjectLesson.find(s => s.id === this.subjectLessonSchedule),
                };
            } else {
                this.newItem = {
                    content: "",
                    subject: "",
                };
            }
        },
        closeDialogAndReset() {
            this.$emit("closeDialog");

            this.$emit("resetStudSelected");
        },
        closeDialog() {
            this.$emit("closeDialog");

            // this.$emit("resetStudSelected");
        },
        async deleteStud() {
            const studObjSelectedCopy = {...this.studObjSelected};
            this.closeDialogAndReset();

            await this.service
                .delete(studObjSelectedCopy.id, "study")
                .then(() => {
                    this.$emit("deleteStudy", studObjSelectedCopy);
                    this.setNewItwmFields();
                    this.openNotification("success", `מעולה`, `דיווח זה נמחק מהמערכת`);
                    this.closeDialogAndReset();
                })
                .catch(() => {
                    this.openNotification(
                        "danger",
                        `אופס`,
                        `קרתה תקלה במחיקת הנתונים מהמערכת`
                    );
                    // this.closeDialogAndReset()
                });
        },
        async post() {
            this.closeDialogAndReset();
            // if ()
            const dateParse = typeof this.date !== 'number' ? Date.parse(this.date) : this.date;
            let validate = true;
            // for (const key in this.newItem) {
            //   if (this.newItem[key] === null) {
            //     validate = false;
            //   }
            // }

            if (validate === true) {
                const objToSend = JSON.parse(JSON.stringify(this.newItem));
                const simpleObj = this.newItem;
                if (!this.studObjSelected) {
                    const id = uuidv4();
                    objToSend.id = id;
                    simpleObj.id = id;
                } else {
                    objToSend.id = this.studObjSelected.id;
                    simpleObj.id = this.studObjSelected.id;
                }
                objToSend.subject = objToSend.subject.id;
                objToSend.grade = this.grade?.id;
                objToSend.date = dateParse;
                objToSend.time = this.lessonTime.id;
                objToSend.user = this.user.id;

                simpleObj.grade = this.grade;
                simpleObj.date = dateParse;
                simpleObj.time = this.lessonTime;
                simpleObj.user = this.user;

                if (!this.studObjSelected) {
                    await this.service
                        .post(objToSend, "study")
                        .then(() => {
                            this.$emit("postStudy", simpleObj);
                            // this.$emit("resetStudSelected");
                            this.setNewItwmFields();
                            this.openNotification("success", `מעולה`, `הדיווח נקלט במערכת`);
                        })
                        .catch(() => {
                            this.openNotification(
                                "danger",
                                `אופס`,
                                `קרתה תקלה בשמירת הנתונים במערכת`
                            );
                        });
                } else {
                    await this.service
                        .update(objToSend, "study")
                        .then(() => {
                            this.$emit("postStudy", simpleObj);
                            this.setNewItwmFields();
                            this.openNotification("success", `מעולה`, `הדיווח שונה במערכת`);
                        })
                        .catch(() => {
                            this.openNotification(
                                "danger",
                                `אופס`,
                                `קרתה תקלה בעדכון הנתונים במערכת`
                            );
                        });
                }
            } else {
                this.openNotification("danger", `אופס`, `חסרים כמה שדות למילוי`);
            }
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({
                color,
                position,
                title,
                text,
                duration,
                progress: "auto",
            });
        },
    },
};
</script>

<style>
.selected-details {
    background: #faf1d4;
    /*border: 1px solid rgba(132, 128, 128, 0.52);*/
}

@media screen and (max-width: 1200px) {
    .p-dialog {
        width: 65vw;
    }
}

@media screen and (max-width: 992px) {
    .p-dialog {
        width: 50vw;
    }
}

@media screen and (max-width: 768px) {
    .p-dialog {
        width: 75vw;
    }
}

@media screen and (max-width: 576px) {
    .p-dialog {
        width: 85vw;
    }
}

.divider-short-dialog:before {
    left: 10% !important;
    /*background: #eaca00;*/
    width: 80%;
}

.t-danger {
    background-color: #ffcdd2;
    color: #c63737;
}

.p-divider-dashed.p-divider-horizontal:before {
    border-top-style: dashed;
    border-top-color: rgba(113, 97, 14, 0.37);
    border-top-width: 1px;
}

.p-divider.p-divider-horizontal:before {
    /*border-top: 1px #f5dd09 !important;*/
}
</style>